var _excluded = ["errorMessage"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { FormHelp } from '@zillow/constellation'; // Pull the error out of the DOM flow so the page doesn't jump when it shows up,
// it will just take up some of the padding space

var StyledErrorWrapper = styled.div.withConfig({
  displayName: "ErrorMessage__StyledErrorWrapper",
  componentId: "sc-fqcwgq-0"
})(["position:absolute;"]);

var ErrorMessage = function ErrorMessage(_ref) {
  var errorMessage = _ref.errorMessage,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledErrorWrapper, null, /*#__PURE__*/React.createElement(FormHelp, _extends({}, props, {
    error: true,
    marginTop: "xs"
  }), errorMessage));
};

export default ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map